// The support line printed on every public page. Kept in one place because the free-consultation
// form still showed a retired number (021-91096350) long after the footer had moved on.
export const SUPPORT_PHONE = '02142364000'
export const SUPPORT_PHONE_LABEL = '021-42364000'
